import EditorMain from "../../../components/EditorMain";
import auditEditorConfig from "../utils/auditEditorConfig";

// Everything that is specific to the mobil audit editor, the rest is the shared EditorMain.
const mobilEditorVariant = {
  config: auditEditorConfig,
};

const AuditKendaraanEditorMain = () => {
  return <EditorMain variant={mobilEditorVariant} />;
};

export default AuditKendaraanEditorMain;
